import listActions from 'src/modules/planificadorTarea/list/planificadorTareaListActions';
import PlanificadorTareaService from 'src/modules/planificadorTarea/planificadorTareaService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'PLANIFICADORTAREA_DESTROY';

const planificadorTareaDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: planificadorTareaDestroyActions.DESTROY_STARTED,
      });

      await PlanificadorTareaService.destroyAll([id]);

      dispatch({
        type: planificadorTareaDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.planificadorTarea.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/planificador-tarea');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: planificadorTareaDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: planificadorTareaDestroyActions.DESTROY_ALL_STARTED,
      });

      await PlanificadorTareaService.destroyAll(ids);

      dispatch({
        type: planificadorTareaDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.planificadorTarea.destroyAll.success'),
      );

      getHistory().push('/planificador-tarea');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: planificadorTareaDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default planificadorTareaDestroyActions;
